import { h } from 'preact'
import ProductPreview from './ProductPreview'
// Tell Babel to transform JSX into h() calls:
/** @jsx h */

const ProductGrid = ({ products, setProductCount }) => {
  let gridClass =
    products.length > 2 ? 'c-product-grid c-product-grid--sb' : 'c-product-grid'
  return (
    <div className={gridClass} style={{ margin: '2rem 0' }}>
      {products.map(product => (
        <ProductPreview
          key={product.id}
          setProductCount={setProductCount}
          product={product}
        />
      ))}
    </div>
  )
}

export default ProductGrid



// WEBPACK FOOTER //
// ./src/js/compare/components/ProductGrid.js